<template>
    <div>
        <div class="test">
            <div class="biao_test">
                帮助中心
            </div>
            <div class="teto_test">
                {{newDate.helpSource}}
            </div>
            <div class="new_de_right_btm">
                <div class="recommend recommend_1">
                    <h1 class="article_s">
                        {{newDate.helpTitle}}
                    </h1>
                    <div>
                        <p class="test_1" v-html="newDate.helpTextContent">
                        </p>
                    </div>
                </div>
            </div>
            <div class="buttom_test">
                <div class="new_left">
                    <div class="prev_1" @click="prev_add">
                        <span>上一篇：</span>{{test_prev||'无'}}
                    </div>
                    <div class="next_1" @click="next_add">
                        <span>下一篇：</span>{{test_next||'无'}}
                    </div>
                </div>
                <div class="new_de_choose_right" @click="fun()">
                    <a href="javascript:;" class="reback">返回</a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "helpCenterDetails",
        data(){
            return{
                newsId: this.$route.params.newsId,
                newDate:{},
                id_prev:'',
                test_prev:'',
                id_next:'',
                test_next:'',
                pageSize: 50,
                pageNum: 1,
            }
        },
        mounted() {
            this.get_data()
            this.get_help()
        },
        methods:{
            get_help(){
                document.querySelector('#app').scrollTop =0
                this.$SIF.httpPost({
                    url: this.$SIF._serve.menhu + "/help/get",
                    data: {id: this.newsId},
                    succFun: res => {
                        this.newDate = res.data
                    },
                    failFun: res => {

                    }
                });
            },
            get_data(){
                var params = {
                    entity: {

                    },
                    pageBean: {
                        pageNum: this.pageNum,
                        pageSize: this.pageSize
                    }
                };
                this.$SIF.httpPost({
                    url: this.$SIF._serve.menhu + "/help/queryPage",
                    data: params,
                    succFun: res => {
                        var newData = res.data.list;
                        // this.sttusCode = res.data.list;
                        this.pages_total = res.data.total;
                        for(var i=0;i<newData.length;i++){
                            if(this.newsId == newData[i].id){

                                if(i >0){
                                    this.id_prev = newData[i-1].id
                                    this.test_prev = newData[i-1].helpTitle
                                }else {
                                    this.test_prev = '无'
                                }
                                if(i != newData.length -1){
                                    this.id_next =newData[i+1].id
                                    this.test_next = newData[i+1].helpTitle
                                }else {
                                    this.test_next = '无'
                                }
                            }
                        }
                    },
                    failFun: res => {

                    }
                });
            },
            fun(){
                this.$router.go(-1); //返回上一层
            },
            prev_add(){
                if(this.id_prev){
                    this.newsId= this.id_prev
                    this.get_data()
                    this.get_help()
                }

            },
            next_add(){
                if(this.id_next){
                    this.newsId= this.id_next
                    this.get_data()
                    this.get_help()
                }

            },
        }
    }
</script>

<style type="text/css">
    .test{
        width: 1200px;
        margin: 0 auto;
        padding: 50px 30px;
    }
    .biao_test{
        width: 100%;
        font-size:40px;
        font-family:NotoSansHans-Regular,NotoSansHans;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:60px;
        letter-spacing:2px;
    }
    .teto_test{
        width: 100%;
        font-size:16px;
        font-family:NotoSansHans-Medium,NotoSansHans;
        font-weight:500;
        color:rgba(49,202,132,1);
        line-height:30px;
        letter-spacing:1px;
        padding: 10px 0;
    }
    .article_s{
        height:22px;
        font-size:22px;
        font-family:NotoSansHans-Regular,NotoSansHans;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:33px;
        letter-spacing:1px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .test_1{
        /*font-size:18px;*/
        /*font-family:NotoSansHans-Regular,NotoSansHans;*/
        /*font-weight:400;*/
        /*color:rgba(102,102,102,1);*/
        /*line-height:20px;*/
        /*letter-spacing:1px;*/
        width: 100%;
        padding: 20px 0;

    }
    .new_left{
        cursor: pointer;
    }
    .test_1 img{
        width: auto;
        max-width: 100%;
    }
    .img_1{
        position: relative;
        left: 30%;
    }
    .test_con{
        text-align: center;
    }
    .test_con_s{
        text-align: center;
    }
    .article_s{
        height:60px;
        line-height: 60px;
        padding-left: 30px;
        background:rgba(245,245,245,1);
    }
    .prev_1:hover,.next_1:hover{
        color: #0FC87D;
    }

    .new_de_right_btm{
        white-space: pre-wrap;
        width: 100%;
        /*border:1px solid rgba(233,233,233,1);*/
    }
    .new_de_right_btm .recommend{
        padding: 0 !important;
    }
    .recommend_1{
        border: 1px solid rgba(233,233,233,1);
    }
    .new_de_right_btm div{
       padding: 0 30px;
    }
    .new_de_choose_left{
        line-height: 16px;
        height: 66px;
    }
    .buttom_test{
        line-height: 12px;
        border:1px solid rgba(233,233,233,1);
        height: 66px;
        overflow: hidden;
        margin-bottom: 30px;
        padding-left: 20px;
    }
    .new_left{
        width: 50%;
        float: left;
    }
    .prev_1 ,.next_1{
        height: 33px;
        line-height: 33px;
        cursor: pointer;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .new_de_choose_right{
        margin: 15px 30px 0 0;
    }

</style>